import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ButtonComponent } from "@components/button/button.component";
import { BlockComponent } from "@components/container-block/block.component";
import { HeaderComponent } from "@components/header/header.component";
import { InputNumberComponent } from "@components/input-number/input-number.component";
import { InputComponent } from "@components/input/input.component";
import { TextareaComponent } from "@components/textarea/textarea.component";
import { TranslatePipe } from "@ngx-translate/core";
import { BusyService } from "~app/common/components/busy/busy.service";
import { CommandService } from "~app/common/services/cqs/command.service";
import { DirtyFormService } from "~app/common/services/dirty-form.service";
import { DirtyTabComponent } from "~app/features/regelverk-viol/dirtyTabComponent";
import { ResponsePanelComponent } from "../../components/response-panel/response-panel.component";
import { SystemadministrationService } from "../../systemadministration.service";

@Component({
    selector: "rask-sysadm-arbetsorder",
    templateUrl: "./sysadm-arbetsorder.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        HeaderComponent,
        BlockComponent,
        ResponsePanelComponent,
        ButtonComponent,
        InputComponent,
        FormsModule,
        TextareaComponent,
        InputNumberComponent,
        TranslatePipe
    ]
})
export class SysadmArbetsorderComponent extends DirtyTabComponent {
    arbetsorderAttSimuleraId = 0;
    arbetsorderBeteckningDirektutbyte: string;
    arbetsorderDistriktResponse: any;
    avverkningsdirektivBeteckningar = "";
    avverkningsdirektivLimit = 100;
    huvudkod: number;
    krontVagvalBeteckning: string;
    krontVagvalSasong = 1;
    recalcArbetsorderGUIDs: string;
    slut: number;
    start: number;

    private readonly administrationService = inject(SystemadministrationService);
    private readonly busyService = inject(BusyService);
    private readonly commandService = inject(CommandService);

    constructor() {
        const dirtyFormService = inject(DirtyFormService);

        super(dirtyFormService);
    }

    addRegelverkCentralaVirkeskop() {
        const cmd = {
            $type: "AddCentralaVirkeskopToRegelverkCommand"
        };
        this.pushCommand(cmd);
    }

    arbetsorderDistriktOmkorning(): void {
        this.arbetsorderDistriktResponse = undefined;
        this.busyService.addWork(this.administrationService.arbetsorderDistriktOmkorning())
            .subscribe(() => {
                this.arbetsorderDistriktResponse = true;
            });
    }

    canSave() {
        // Tom, ingen användning här
    }

    enqueueActiveAvverkningsdirektivCommand(limit?: number): void {
        const cmd = { $type: "EnqueueActiveAvverkningsdirektivCommand",
            limit: limit };
        this.pushCommand(cmd);
    }

    enqueueAvverkningsdirektiv(beteckning: string): void {
        const cmd = { $type: "EnqueueAvverkningsdirektivCommand",
            beteckning: beteckning };
        this.pushCommand(cmd);
    }

    isDirtyCheck(): boolean {
        return false;
    }

    pushCommand(cmd) {
        this.commandService.addTransactionCommand(cmd);
        const obs = this.commandService.pushCommandQueueTransaction();

        this.busyService.addWork(obs);
        obs.subscribe(x => {
            this.commandService.reset();
        });
    }

    pushCommands(cmds: any[]) {
        cmds.forEach(cmd => {
            this.commandService.addTransactionCommand(cmd);
        });

        const obs = this.commandService.pushCommandQueueTransaction();
        this.busyService.addWork(obs);
        obs.subscribe(x => {
            this.commandService.reset();
        });
    }

    recalculateDirektutbyte() {
        const cmd = {
            $type: "RecalculateArbetsorderDirektutbyteCommand",
            arbetsorderBeteckning: this.arbetsorderBeteckningDirektutbyte
        };
        this.pushCommand(cmd);
    }

    rerunRecalculateArbetsorderVolymer(recalcArbetsorderGUIDs: string) {
        const guidlist = recalcArbetsorderGUIDs.split(",").map(b => b.trim());
        const cmdlist = guidlist.map(guid => ({ $type: "RecalculateArbetsorderVolymCommand",
            arbetsorderGuid: guid }));
        return this.pushCommands(cmdlist);
    }

    restoreChanges() {
        // Tom, ingen användning här
    }

    saveChanges() {
        // Tom, ingen användning här
    }

    seedVirkesordernummer(huvudkod: number, start: number, slut: number): void {
        const cmd = {
            $type: "SeedVirkesordernummerCommand",
            huvudkod: huvudkod,
            start: start,
            slut: slut
        };
        this.pushCommand(cmd);
    }

    utbyteSimuleraArbetsorder() {
        if(this.arbetsorderAttSimuleraId !==  0) {
            this.administrationService.utbyteSimuleraArbetsorder(this.arbetsorderAttSimuleraId).subscribe();
        }
    }
}
